"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseInternetAccountConfig = void 0;

var _configuration = require("../../configuration");

var BaseInternetAccountConfig = (0, _configuration.ConfigurationSchema)('InternetAccount', {
  name: {
    description: 'descriptive name of the internet acount',
    type: 'string',
    defaultValue: ''
  },
  description: {
    description: 'a description of the internet account',
    type: 'string',
    defaultValue: ''
  }
}, {
  explicitIdentifier: 'internetAccountId',
  explicitlyTyped: true
});
exports.BaseInternetAccountConfig = BaseInternetAccountConfig;